import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { NCCC_LOGO } from "../lib/assets";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div
      className="relative z-10 min-h-[80vh] flex items-center justify-center px-6"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md border border-[color:var(--nccc-border)] bg-[color:var(--nccc-surface)] p-10">
        <div className="flex items-center gap-3 mb-8">
          <img
            src={NCCC_LOGO}
            alt="NCCC"
            className="w-12 h-12 object-contain"
          />
          <div>
            <div className="label-accent">// Operator</div>
            <div className="font-display text-lg text-[color:var(--nccc-cream)]">
              Restricted channel
            </div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="label">Email</label>
            <input
              data-testid="admin-login-email"
              type="email"
              className="nccc-input mt-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="label">Password</label>
            <input
              data-testid="admin-login-password"
              type="password"
              className="nccc-input mt-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && (
            <p className="text-[color:var(--nccc-rust)] text-sm" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="nccc-btn w-full justify-center"
            data-testid="admin-login-submit"
          >
            {busy ? "Tuning in..." : "Enter"}
          </button>
        </form>

        <Link
          to="/"
          className="block text-center label mt-6 hover:text-[color:var(--nccc-ochre)]"
          data-testid="admin-login-back"
        >
          ← back to surface
        </Link>
      </div>
    </div>
  );
}
